import React, { PureComponent } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Expander } from '@components/Expander'
import { GroupLink } from '../GroupLink'
import {
  GroupName,
  ExpandedContainer,
  getHeadingStyles,
} from './AccordionNavItem.elements'

type Props = {
  navGroup: NavGroupType
  isOpen: boolean
  onItemSelect?: () => void
  onToggle: (groupKey: string) => void
}

export class AccordionNavItem extends PureComponent<Props> {
  handleToggle = () => {
    const { onToggle, navGroup } = this.props
    onToggle(navGroup.key)
  }

  renderExpandedContent() {
    const { navGroup, onItemSelect } = this.props

    return (
      <ExpandedContainer>
        {navGroup.sections.map((section, idx) => (
          <GroupLink
            key={idx}
            links={section.links}
            title={section.title}
            onItemSelect={onItemSelect}
          />
        ))}
      </ExpandedContainer>
    )
  }

  render() {
    const { navGroup, isOpen } = this.props

    return (
      <Expander
        expandedContent={this.renderExpandedContent()}
        isOpen={isOpen}
        label={navGroup.title}
        onToggle={this.handleToggle}
        css={getHeadingStyles(isOpen)}
      >
        <GroupName>
          {navGroup.title}
        </GroupName>
      </Expander>
    )
  }
}
